<script setup lang="ts">
import type { MenuItem } from '@/types/user'

import { type PropType } from 'vue'
import RecursiveMenu from './RecursiveMenu.vue'

const ADMIN_PREFIX = '/admin'

defineProps({
  menuData: { type: Array as PropType<MenuItem[]>, require: true }
})

/** 将数据库路径转为完整 admin 路径 */
const menuIndex = (path: string) => {
  if (path.startsWith(ADMIN_PREFIX)) return path
  return ADMIN_PREFIX + path
}
</script>
<template>
  <template v-for="menuItem in menuData" :key="menuItem.menuId">
    <!-- 有子级菜单的时候  el-sub-menu-->
    <el-sub-menu :index="menuIndex(menuItem.path)" v-if="menuItem.children && menuItem.children.length > 0">
      <template #title>
        <el-icon>
          <component :is="menuItem.icon"></component>
        </el-icon>
        <span>{{ menuItem.title }}</span>
      </template>
      <RecursiveMenu :menuData="menuItem.children" />
    </el-sub-menu>
    <!-- 没有子级菜单的时候  el-menu-item -->
    <el-menu-item v-else :index="menuIndex(menuItem.path)">
      <el-icon>
        <component :is="menuItem.icon"></component>
      </el-icon>
      <span>{{ menuItem.title }}</span>
    </el-menu-item>
  </template>
</template>
<style scoped lang="scss"></style>
